import React from 'react';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export type TabProps = {
  isActive?: boolean;
  label: React.ReactNode;
  link?: string;
  onClick?: () => void;
};

const Container = styled.a`
  color: ${Colors.GRAY_DARK_20};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 ${Spacing.SINGLE};

  &:hover {
    color: ${Colors.GRAY_DARK_20};
  }
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  ${Font.bySize(Font.Size.S, Font.Weight.NORMAL)}
`;

const ActiveLine = styled.div<{ isActive?: boolean }>`
  background: ${Colors.GRAY_DARK_30};
  height: ${Spacing.QUARTER};
  margin-top: -${Spacing.QUARTER};
  margin-left: -${Spacing.HALF};
  width: calc(100% + ${Spacing.SINGLE});
  opacity: ${ifProp('isActive', 1, 0.5)};
  transform: translateY(${ifProp('isActive', 0, Spacing.QUARTER)});
  transition: opacity ${Transition.Time.BASE}, transform ${Transition.Time.BASE};
  ${Mixins.Border.setTopSide(Spacing.HALF)}

  ${Container}:hover & {
    transform: translateY(0);
  }
`;

export const Tab: React.FC<TabProps> = (props) => {
  const { isActive, label, onClick } = props;

  return (
    <Container onClick={onClick}>
      <LabelContainer>{label}</LabelContainer>
      <ActiveLine isActive={isActive} />
    </Container>
  );
};
